import { render, staticRenderFns } from "./QuestionGroupView.vue?vue&type=template&id=7d507e30&scoped=true&"
import script from "./QuestionGroupView.vue?vue&type=script&lang=ts&"
export * from "./QuestionGroupView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d507e30",
  null
  
)

export default component.exports